// extracted by mini-css-extract-plugin
export default {"tooltipContent":"TRDthD","tooltipBase":"V5D5gz","tooltipTitle":"BHmUFJ"};